const roiSimulation = {
  pageName: 'Optimization Summary',
  subtitle: 'Compare a baseline operational run vs a MoveAI optimized run, then convert deltas into an ROI story.',
  controls: {
    title: 'Select runs to compare',
    grid: 'Grid',
    table: 'Table',
    filters: {
      baseline: {
        title: 'Baseline run',
        description: `Pulls KPIs for the selected date using the client's current workflow.`,
      },
      moveAI: {
        title: 'MoveAI run',
        description: `Pulls KPIs for the optimized run, generated by MoveAI for the same operation.`,
      },
      load: 'Load',
      loaded: 'Loaded',
    },
  },
  barGraph: {
    title: 'Key Deltas (Baseline vs MoveAI)',
    kpisSelected: 'KPIs selected',
    selectKpis: 'Select KPIs to display',
    selected: 'selected',
  },
  kpiComparisons: {
    title: 'KPI Comparisons',
    resetKpis: 'Reset KPIs',
    showDiffAs: 'Show diff as:',
    absolute: 'Absolute',
    percentage: '%',
  },
  roiInputs: {
    title: 'ROI Inputs',
    reset: 'Reset',
    perMonth: 'per month',
    tabs: {
      laborSavings: 'Labor savings',
      supplierCosts: 'Supplier costs',
      feesHorizon: 'Fees & horizon',
    },
    labor: {
      dispatchersToday: 'Dispatchers today',
      dispatchersTodayTooltip: 'Number of dispatchers currently employed.',
      dispatchersWithMoveAI: 'Dispatchers with MoveAI',
      dispatchersWithMoveAITooltip: 'Estimated dispatchers needed after MoveAI.',
      costPerDispatcher: 'Cost per dispatcher',
      hoursPerDay: 'Hours per day',
      workingDaysPerMonth: 'Working days per month',
      currency: 'Currency',
      savingsTitle: 'Estimated dispatcher savings (monthly)',
      savingsDescription: 'Based on dispatchers reduced × hourly cost × hours/day × working days/month.',
    },
    supplier: {
      costsToday: 'Supplier costs today (monthly)',
      costsWithMoveAI: 'Supplier costs with MoveAI (monthly)',
      savingsTitle: 'Supplier savings (monthly)',
      savingsDescription: 'Baseline supplier costs minus MoveAI supplier costs.',
      totalSavingsTitle: 'Total savings (monthly)',
      totalSavingsDescription: 'Labor + supplier savings.',
    },
    fees: {
      paymentPlan: 'Payment plan',
      roiHorizon: 'ROI horizon',
      platformMonthlyFee: 'Platform monthly fee',
      oneTimeImplementationFee: 'One-time implementation fee',
      avgBookingsPerMonth: 'Avg bookings per month',
      platformBookingFee: 'Platform booking fee',
      totalCostTitle: 'Total cost (horizon)',
      totalCostDescription: 'Implementation + (monthly fees × horizon).',
      paybackTitle: 'Payback time',
      paybackDescription: 'Total cost / (monthly savings - monthly fee).',
      roiTitle: 'ROI',
      roiDescription: 'Net benefit over horizon / total cost.',
      monthlyFee: 'Monthly fee',
      perBookingFee: 'Per booking fee',
    },
    executiveSummary: {
      title: 'Executive Summary',
      dispatcherSavings: 'Estimated dispatcher savings (monthly)',
      supplierSavings: 'Supplier savings (monthly)',
      totalSavings: 'Total savings (monthly)',
      totalCost: 'Total cost (horizon)',
      paybackTime: 'Payback time',
      roi: 'ROI',
    },
    suffix: {
      hrs: 'hrs',
      days: 'days',
      day: 'day',
      hr: '/hr',
      months: 'months',
    },
  },
  roiCardsContainer: {
    kpis: {
      totalReservations: 'Total Bookings',
      assignedReservations: 'Assigned Bookings',
      unassignedReservations: 'Unassigned Bookings',
      sharedRideReservations: 'Shared Bookings',
      totalTrips: 'Total Trips',
      assignedTrips: 'Assigned Trips',
      unassignedTrips: 'Unassigned Trips',
      sharedRideTrips: 'Shared Trips',
      driversWithShifts: 'Drivers with Shifts',
      assignedDrivers: 'Assigned Suppliers',
      avgTripsPerDriver: 'Avg Trips / Supplier',
      avarageBookingsPerDriver: 'Avg Bookings / Supplier',
      averageTripsDistance: 'Avg Trip Distance',
      averageTripsDuration: 'Avg Trip Duration',
      averageDeadheadDistance: 'Avg Deadhead',
      averageIdleTime: 'Avg Idle Time',
      totalEarnings: 'Total Earnings',
      earningPerHour: 'Earnings per Hour',
      averageTripsEarnings: 'Avg Trips Earnings',
      averageEarningsPerDriver: 'Avg Earnings / Supplier',
      totalCost: 'Total Cost',
    },
    baseline: 'Baseline',
    moveAI: 'MoveAI',
    noChange: 'No Change',
    disabled: 'Disabled',
    kilometers: 'km',
    minutes: 'min',
    currency: '$',
    k: 'k',
    plus: '+',
    minus: '-',
    percentage: '%',
  },
  tableView: {
    kpiName: 'KPI Name',
    diff: 'Diff',
    exportTable: 'Export Table',
    kpis: 'KPIs',
    exportedAt: 'Data exported at: {{date}}',
  },
  filters: {
    suppliers: {
      title: 'Supplier:',
      placeholder: 'Supplier',
    },
    attributes: {
      title: 'Attribute:',
      placeholder: 'Attribute',
    },
  },
};

export default roiSimulation;
